import { settings } from '@/main/config/settings'

/**
 * LaunchDarkly configuration
 * Initializes with an anonymous user context to ensure flags are ready immediately
 */
export default {
  clientSideID: settings.LAUNCH_DARKLY_CLIENT_ID,
  context: {
    kind: 'user',
    key: '00000000-0000-0000-0000-000000000000',
    anonymous: true
  },
  options: {
    bootstrap: 'localStorage' as const,
    streaming: true,
    evaluationReasons: true
  }
}
